/**
 * Archive page help menusJS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class ArchiveHelpmenu
 */
class ArchiveHelpmenu {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.helpmenuToggler      = $( '#js-help-menu-toggler' );
        this.helpmenuDropdown     = $( '#js-help-menu-dropdown' );
        this.helpmenuDropdownIcon = $( '#js-dropdown-icon' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Slide toggle the helpmenu dropdown when clicking the toggler
        this.helpmenuToggler.on( 'click', ( e ) => {
            this.helpmenuDropdown.slideToggle( 'fast' );

            // Update the togglers aria-expanded
            const ariaExpanded = this.helpmenuToggler.attr( 'aria-expanded' );

            if ( ariaExpanded == 'false' ) {
                this.helpmenuToggler.attr( 'aria-expanded', 'true' );
            } else {
                this.helpmenuToggler.attr( 'aria-expanded', 'false' );
            }

            this.helpmenuDropdownIcon.toggleClass( 'rotate' );
        });

    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = ArchiveHelpmenu;



// WEBPACK FOOTER //
// ./assets/scripts/archive-helpmenu.js